module.exports = __webpack_public_path__ + "static/media/15.2ca929d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/15.png
// module id = 1345
// module chunks = 0